const isPlainObject = require('lodash/isPlainObject');
const functionsIn = require('lodash/functionsIn');
const isFunction = require('lodash/isFunction');
const bindAll = require('lodash/bindAll');

module.exports = function(obj) {
  let methods = isPlainObject(obj)
    ? functionsIn(obj)
    : Object.getOwnPropertyNames(Object.getPrototypeOf(obj));

  methods = methods
    .filter(method => method !== 'constructor')
    .filter(method => isFunction(obj[method]));

  return bindAll(obj, methods);
};
